function initHourRangeInputs() {

    $(".hourrange").each(function () {
        hourRangeUpdated($(this));
    });

    $(document).on('input', '.hourrange', function () {
        hourRangeUpdated($(this))
    });
}

function hourRangeUpdated(selector) {
    selector.next('.info').html(selector.val() + 'h');
}
